import React, { createContext, useContext, ReactNode } from 'react';
import { useNWC } from '@/hooks/useNWC';

interface NWCContextType {
  connections: any[];
  activeConnection: string | null;
  addConnection: (uri: string, alias?: string) => Promise<boolean>;
  removeConnection: (uri: string) => void;
  setActiveConnection: (uri: string) => void;
  getActiveConnection: () => any | null;
}

const NWCContext = createContext<NWCContextType | undefined>(undefined);

export function NWCProvider({ children }: { children: ReactNode }) {
  const nwc = useNWC();

  return (
    <NWCContext.Provider value={nwc}>
      {children}
    </NWCContext.Provider>
  );
}

export function useNWCContext() {
  const context = useContext(NWCContext);
  if (!context) {
    throw new Error('useNWCContext must be used within a NWCProvider');
  }
  return context;
}
